/**
 * NIFTY analyzer strategy_type values accepted by POST /api/v1/auto-trade/start
 * (must stay in sync with main-backend AUTOTRADE_ALLOWED_STRATEGY_TYPES).
 */
export const AUTOTRADE_STRATEGY_OPTIONS = [
  { value: 'zone_reversal', label: 'Zone reversal' },
  { value: 'pivot_breakout', label: 'Pivot breakout' },
  { value: 'ema_pullback_continuation', label: 'EMA pullback continuation' },
  { value: 'pivot_trend_continuation', label: 'Pivot trend continuation' },
  { value: 'daily_supertrend_reversal', label: 'Daily SuperTrend reversal' },
  { value: 'ath_fade', label: 'ATH fade' },
  { value: 'ema7_touch_15m', label: 'EMA7 touch (15m)' },
  { value: 'ma_ribbon_cloud_atr', label: 'MA Ribbon Cloud ATR' },
  { value: 'ema_scalp', label: 'EMA scalp' },
  { value: 'inside_bar', label: 'Inside bar' },
  { value: 'vwap_pullback', label: 'VWAP pullback' },
  { value: 'master_strategy', label: 'Master strategy' },
];
